/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="47.6"
        height="49.63"
        viewBox="0 0 47.6 49.63"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <g
          fill="none"
          strokeLinejoin="round"
          strokeLinecap="round">
          <path
            stroke="#ffb81c"
            d="M32.47 38.53a7.5 7.5 0 1 1 7.5-7.5 7.5 7.5 0 0 1-7.5 7.5Z"
            className="icon-stroke icon-accent"
            strokeWidth="1.04"/>
          <path
            stroke="#ffb81c"
            d="M32.47 38.53c-1.78 0-3.14-3.21-3.14-7.48s1.33-7.52 3.14-7.52 3.14 3.21 3.14 7.49-1.33 7.51-3.14 7.51ZM25.97 27.28h13M24.97 31.03h15M25.95 34.73h13.02"
            className="icon-stroke icon-accent"
            strokeWidth="1.04"/>
          <path
            stroke="#0e497b"
            d="m27.49 39.07-3.71-.06M23.79 39.01l.83 3.68M42.59 37.06a11.32 11.32 0 0 1-3 3.54A11.46 11.46 0 0 1 23.81 39M27.89 22.92l1.93-3.17M29.82 19.75l-3.6-1.14M20.97 34.74a10.87 10.87 0 0 1-.51-2.15 11.48 11.48 0 0 1 9.36-12.82M42.33 30.44l2.11 3.05M44.44 33.49l2.51-2.81M34.4 19.79a11.77 11.77 0 0 1 2.16.42c5.91 1.75 9.35 7.32 7.85 13.32"
            className="icon-stroke icon-base"
            strokeWidth="1.3"/>
          <path
            stroke="#0e497b"
            d="M26.28 46.36a22.67 22.67 0 0 1-5.61 2.62c-18.12-6.5-20-20.39-20-32.89V8.2C8.75 7.95 15.28 5.53 20.68.65c5.44 4.88 11.93 7.3 20 7.55v9.27"
            className="icon-stroke icon-base"
            strokeWidth="1.3"/>
        </g>
      </svg>

    );
  }
}

Icon.displayName = 'ShieldWithGlobe3ArrowsIcon';

export default Icon;
